import { render, staticRenderFns } from "./TagEditPage.vue?vue&type=template&id=88a3f74e&"
import script from "./TagEditPage.vue?vue&type=script&lang=js&"
export * from "./TagEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports